import { Injectable, EventEmitter } from "@angular/core";

@Injectable({
    providedIn: "root",
})
export class EdpMouseEventService {
    public $mouseEvent: EventEmitter<any> = new EventEmitter();


    public emitMouseEvent(event: Event): any {
        this.$mouseEvent.next(event);
    }

}
